import { render } from "./termsOfUseConfigView.vue?vue&type=template&id=523c2e8c&scoped=true"
import script from "./termsOfUseConfigView.vue?vue&type=script&lang=js"
export * from "./termsOfUseConfigView.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-523c2e8c"

export default script